document.addEventListener("DOMContentLoaded", () => {
  const DAY_IN_MS = 86400000;
  const HOUR_IN_MS = 3600000;
  var cutoff = 4; // 4 is Thursday

  function getNextOccurrenceOfWeekday(weekday) {
    let today = new Date();
    let dayToday = today.getDay() || 7;
    let daysUntilNextWeekday = weekday - dayToday;
    if (
      daysUntilNextWeekday < 0 ||
      (daysUntilNextWeekday === 0 && today.getHours() >= 12)
    ) {
      daysUntilNextWeekday += 7;
    }
    let nextWeekday = new Date(
      today.getTime() + daysUntilNextWeekday * DAY_IN_MS
    );
    nextWeekday.setHours(12, 0, 0, 0);
    return nextWeekday.getTime() / 1000;
  }

  var currentTimer = getNextOccurrenceOfWeekday(cutoff);

  // Setup timer and display
  var homepage = document.getElementById("homepage");
  if (homepage) {
    var flipdown = new FlipDown(currentTimer, "homepage").start();

    let body = document.body;
    body.classList.toggle("light-theme");
    homepage.classList.toggle("flipdown__theme-light");

    var ver = document.getElementById("ver");
    ver.innerHTML = flipdown.version;
  }

  // Update timer every hour
  setInterval(() => {
    let now = new Date();
    if (now.getDay() === cutoff && now.getHours() >= 12) {
      currentTimer = getNextOccurrenceOfWeekday(cutoff);
      flipdown = new FlipDown(currentTimer, "homepage").start();
    }
  }, HOUR_IN_MS);
});
